'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _preventDefault = require('../../utils/preventDefault');

var _preventDefault2 = _interopRequireDefault(_preventDefault);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CardStatusBanner = require('./CardStatusBanner.scss');

var _CardStatusBanner2 = _interopRequireDefault(_CardStatusBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardStatusBanner = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CardStatusBanner, _Component);

    function CardStatusBanner() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CardStatusBanner);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardStatusBanner.__proto__ || (0, _getPrototypeOf2.default)(CardStatusBanner)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = _preventDefault2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CardStatusBanner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.catalogRegistration, nextProps.catalogRegistration, ['declined', 'pending']) || (0, _propsComparer2.default)(this.props.item, nextProps.item, ['isAvailable', 'isPassed']) || (0, _propsComparer2.default)(this.props.biddingInfo, nextProps.biddingInfo, ['bidderHasHighBid', 'isReserveMet']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                biddingInfo = _props.biddingInfo,
                catalogRegistration = _props.catalogRegistration,
                item = _props.item;
            var bidderHasHighBid = biddingInfo.bidderHasHighBid,
                isReserveMet = biddingInfo.isReserveMet;


            if ((0, _isEmpty2.default)(biddingInfo)) {
                return null;
            }

            var blockedByAuctioneer = catalogRegistration.blockedByAuctioneer,
                declined = catalogRegistration.declined,
                pending = catalogRegistration.pending,
                suspended = catalogRegistration.suspended;
            var isAvailable = item.isAvailable,
                isPassed = item.isPassed;


            var statusMessageClass = '';
            var statusMessage = '';

            if (declined) {
                statusMessage = 'registration_declined';
                statusMessageClass = _CardStatusBanner2.default.pending;
            } else if (blockedByAuctioneer || suspended) {
                statusMessage = 'account_suspended';
                statusMessageClass = _CardStatusBanner2.default.pending;
            } else if (isAvailable) {
                if (pending) {
                    statusMessage = 'pending_approval';
                    statusMessageClass = _CardStatusBanner2.default.pending;
                } else if (bidderHasHighBid && isReserveMet) {
                    statusMessage = 'you_are_leading';
                    statusMessageClass = _CardStatusBanner2.default.leading;
                } else if (bidderHasHighBid && !isReserveMet) {
                    statusMessage = 'reserve_not_met';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                } else {
                    statusMessage = 'outbid';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                }
            } else if (isPassed) {
                if (pending) {
                    statusMessage = 'not_approved';
                    statusMessageClass = _CardStatusBanner2.default.pending;
                } else {
                    statusMessage = 'lot_passed';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                }
            } else if (bidderHasHighBid) {
                statusMessage = 'you_won';
                statusMessageClass = _CardStatusBanner2.default.leading;
            } else {
                statusMessage = 'lost';
                statusMessageClass = _CardStatusBanner2.default.warning;
            }

            return (0, _jsx3.default)('div', {
                onClick: this.onClick,
                className: _CardStatusBanner2.default['bid-status'] + ' ' + statusMessageClass
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: statusMessage
            }));
        }
    }]);
    return CardStatusBanner;
}(_react.Component), _class.defaultProps = {
    biddingInfo: {},
    catalogRegistration: {},
    item: {}
}, _temp2);
exports.default = CardStatusBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/CardStatusBanner.js
// module id = SCYO
// module chunks = 46